module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-12.0e007b00.png";